import { type Control, Controller } from 'react-hook-form'
import { StyleSheet, View } from 'react-native'
import { Card, Text } from 'react-native-paper'
import type { LocationMutatableData } from '@/types/locations'
import { TextAreaInput, TextInput, Toggle } from '@/ui/form'
import { PointMap } from '@/ui/form/PointMap'
import { TagSelect } from '@/ui/jobs/TagSelect'

interface LocationFormFieldsProps {
    control: Control<LocationMutatableData>
}

export function LocationFormFields({ control }: LocationFormFieldsProps) {
    return (
        <>
            <Card style={styles.card}>
                <View style={styles.cardContent}>
                    <Text variant="headlineSmall" style={styles.cardTitle}>
                        Location Information
                    </Text>

                    <TextInput
                        autoFocus
                        control={control}
                        name="name"
                        label="Location Name *"
                        placeholder="Enter location name"
                    />

                    <TextAreaInput
                        control={control}
                        name="description"
                        label="Description"
                        placeholder="Optional description for this location"
                        numberOfLines={3}
                    />

                    <TagSelect control={control} name="tags" label="Tags" />

                    <View style={{ alignSelf: 'flex-end', gap: 8 }}>
                        <Toggle control={control} name="inactive" label="Inactive" />
                    </View>
                </View>
            </Card>

            <Card style={styles.card}>
                <View style={styles.cardContent}>
                    <Text variant="headlineSmall" style={styles.cardTitle}>
                        Job Location & Radius
                    </Text>

                    <Controller
                        control={control}
                        name="geometry"
                        render={({ field: { value, onChange } }) => (
                            <PointMap value={value} onChange={onChange} />
                        )}
                    />
                </View>
            </Card>
        </>
    )
}

const styles = StyleSheet.create({
    card: {
        padding: 16,
        margin: 0,
        marginBottom: 16,
    },
    cardContent: {
        gap: 16,
    },
    cardTitle: {
        fontWeight: '600',
    },
})
